import React, { useState } from 'react';
import { Helmet } from 'react-helmet'; // ▼▼▼ 追加 ▼▼▼
import { useLocation } from 'react-router-dom'; // ▼▼▼ 追加 ▼▼▼
import './Garden.css';

const Renovation = () => {
    const [lightboxImage, setLightboxImage] = useState(null);
    const { pathname } = useLocation(); // ▼▼▼ 追加 ▼▼▼

    // Lightboxを開くための関数
    const openLightbox = (imageSrc) => {
        setLightboxImage(imageSrc);
    };

    return (
        <>
            {/* ▼▼▼ このHelmetブロックを丸ごと追加します ▼▼▼ */}
            <Helmet>
                <title>快適性と歴史の風情｜5つの魅力｜金沢之旅宿 あけぼの</title>
                <meta name="description" content="150年の歴史を持つ金沢町家をフルリノベーション。趣ある梁や壁はそのままに、最新のキッチンや浴室、快適な空調を完備。あけぼので伝統と現代が融合した特別な滞在を。" />
                <link rel="canonical" href={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:title" content="快適性と歴史の風情｜金沢之旅宿 あけぼの" />
                <meta property="og:description" content="150年の歴史を持つ金沢町家をフルリノベーション。趣ある梁や壁はそのままに、最新の設備を完備。" />
                <meta property="og:url" content={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:image" content="https://kanazawa-stay-akebono.com/images/feature-renovation.jpg" />
            </Helmet>
            {/* ▲▲▲ ここまで追加 ▲▲▲ */}        <div className="akebono-garden-page">

                {/* HEROセクション */}
                <section className="akebono-garden-hero" style={{ backgroundImage: "url('/images/feature-renovation.jpg')" }}>
                    <div className="akebono-garden-hero-overlay">
                        <h1>快適と伝統が融合する空間</h1>
                    </div>
                </section>

                {/* セクション①：リノベーションの概要 */}
                <section className="akebono-garden-culture">
                    <h2>金澤町屋を快適に</h2>
                    <p>
                        あけぼの は、150年以上の歴史を持つ金澤町屋の魅力をそのままに、2019年にフルリノベーションを実施いたしました。
                        壁や梁などの趣ある構造を残しつつ、冷暖房・水回りなどはすべて最新設備を導入しております。
                    </p>
                    <p>
                        館内は170㎡の広さがあり、8名様でもゆったりとお過ごしいただけます。古き良き町家の雰囲気と、現代的な快適性を兼ね備えた宿で、どうぞ心ゆくまでご滞在をお楽しみください。
                    </p>
                    <div className="akebono-garden-gallery">
                        <img src="/images/room.jpg" alt="町家の室内" onClick={() => openLightbox('/images/room.jpg')} />
                        <img src="/images/renovation1.jpg" alt="リビングの様子" onClick={() => openLightbox('/images/renovation1.jpg')} />
                        <img src="/images/renovation2.jpg" alt="ダイニングとキッチン" onClick={() => openLightbox('/images/renovation2.jpg')} />
                    </div>
                </section>

                {/* セクション②：ダイニング・キッチン */}
                <section className="akebono-garden-feature">
                    <h2>ダイニングとキッチン</h2>
                    <p>
                        ダイニングにはカウンターテーブルをご用意。4名様が並んで座れるスペースで、朝食やコーヒータイムをゆっくりとお楽しみいただけます。
                    </p>
                    <p>
                        キッチンはIHコンロなど最新設備を備え、8名様分の食器やカトラリーも完備しております。旅先でも快適に調理や団らんができる空間です。
                    </p>
                    <h3>キッチン用品一覧</h3>
                    <ul>
                        <li>IHコンロ（2口）</li>
                        <li>冷蔵庫（冷凍室あり）</li>
                        <li>電子レンジ、トースター、電気ケトル、食器乾燥機、炊飯器</li>
                        <li>調理器具一式（お鍋、フライパン、包丁、まな板、フライ返し、お玉など）</li>
                        <li>食器類（お皿、お椀、カトラリー類など）</li>
                        <li>ふきん、キッチン洗剤、スポンジ、コーヒー</li>
                    </ul>
                    <div className="akebono-garden-gallery">
                        <img src="/images/kicthen.jpg" alt="キッチン" onClick={() => openLightbox('/images/kicthen.jpg')} />
                        <img src="/images/kicthen2.jpg" alt="キッチン用品" onClick={() => openLightbox('/images/kicthen2.jpg')} />
                        <img src="/images/kicthen3.jpg" alt="ダイニング" onClick={() => openLightbox('/images/kicthen3.jpg')} />
                        <img src="/images/kicthen4.jpg" alt="調理スペース" onClick={() => openLightbox('/images/kicthen4.jpg')} />
                    </div>
                </section>

                {/* セクション③：水回りの設備 */}
                <section className="akebono-garden-feature">
                    <h2>浴室・洗面・お手洗い</h2>
                    <p>
                        浴室は窓を開放すれば中庭を望む半露天風呂としてもお楽しみいただけます（シャッターで目隠しも可能）。
                        洗面台は2名様同時に使用可能な広々とした設計。
                    </p>
                    <p>
                        ドラム式洗濯機もご用意。2か所のお手洗いはいずれも温水洗浄便座付きで、快適なご滞在をサポートします。
                    </p>
                    <h3>アメニティ一覧</h3>
                    <ul>
                        <li>ドライヤー、衣類スチーマー、洗濯洗剤</li>
                        <li>バスタオル／フェイスタオル／ウォッシュタオル</li>
                        <li>シャンプー／コンディショナー／ボディソープ／ハンドソープ</li>
                        <li>歯ブラシ／歯磨き粉</li>
                        <li>Wi-Fi、エアコン、浴衣</li>
                    </ul>
                    <div className="akebono-garden-gallery">
                        <img src="/images/bath1.jpg" alt="浴室" onClick={() => openLightbox('/images/bath1.jpg')} />
                        <img src="/images/bath2.jpg" alt="洗面台" onClick={() => openLightbox('/images/bath2.jpg')} />
                        <img src="/images/bath3.jpg" alt="洗濯機" onClick={() => openLightbox('/images/bath3.jpg')} />
                        <img src="/images/bath4.jpg" alt="お手洗い" onClick={() => openLightbox('/images/bath4.jpg')} />
                    </div>
                </section>

                {/* セクション④：玄関・アクセス性 */}
                <section className="akebono-garden-feature">
                    <h2>玄関と出入口</h2>
                    <p>
                        表門には、あけぼの の暖簾が掲げられており、宿の趣を印象づけます。正面玄関はデジタルキーによる管理となっており、鍵の持ち歩きも不要です。
                        チェックイン・アウトもスムーズに行えるよう配慮された設計です。
                    </p>
                </section>

                {/* Lightbox */}
                {lightboxImage && (
                    <div className="lightbox" onClick={() => setLightboxImage(null)}>
                        <span className="lightbox-close">&times;</span>
                        <img src={lightboxImage} alt="拡大表示" className="lightbox-content" />
                    </div>
                )}
            </div>
        </> // ▲▲▲ 全体をフラグメント <> で囲みます ▲▲▲

    );
};

export default Renovation;